import {Button} from '_core'
import {OrderCard} from 'app/features/orders/componentsv1'
import eventPublishService from 'app/services/EventPublishService/EventPublishService'
import {useMemo, useState} from 'react'
import {useDispatch} from 'react-redux'
import {useNavigate, useParams} from 'react-router-dom'
import {toAbsoluteUrl} from '_metronic/helpers'
import {showMessage} from 'app/redux/messageSlice'
import ConfirmationDialog from '_core/components/ConfirmationDialog'
import toLower from 'lodash/toLower'
import isString from 'lodash/isString'
import {integrationAppsList} from 'app/constant'
interface Props {
  message: any
  appType: string
}

const TrackingItem: React.FC<Props> = ({message, appType}) => {
  const {orderId} = useParams<any>()
  const dispatch = useDispatch()
  const history = useNavigate()
  const [showDialog, setShowDialog] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const app = useMemo(
    () => integrationAppsList.find((app: any) => app.appType === appType),
    [appType]
  )

  const handleSave = async () => {
    try {
      setIsSubmitting(true)
      await eventPublishService.createExternalOrder({
        id: orderId,
        appType: toLower(appType),
      })
      history('/orders')
    } catch (error) {
      dispatch(showMessage({text: 'An error occurred while saving order', variant: 'error'}))
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleOpen = () => {
    setShowDialog(true)
  }
  const handleClose = () => {
    setShowDialog(false)
  }

  return (
    <>
      <OrderCard
        title={
          <>
            {' '}
            <div className='symbol symbol-35px me-5'>
              <img
                alt='Logo'
                src={toAbsoluteUrl(`/media/images/${app?.imgURL}.png`)}
                className='h-35px'
              />
            </div>
            {app?.title}
          </>
        }
        className='py-6'
        toolbar={
          <Button
            id='externalOrderTracking'
            className='btn btn-sm btn-transparent btn-link'
            title='Reprocess Order'
            onClick={handleOpen}
          />
        }
      >
        <div className='d-flex align-items-center'>
          {message?.errors ? (
            <h5 className='mb-1'>
              To save this order, {message.errors?.length} change needs to be made:
            </h5>
          ) : (
            isString(message) && (
              <h5 className='mb-1'>To save this order, change needs to be made:</h5>
            )
          )}
        </div>
        <div>
          {message?.errors && message.errors?.length ? (
            <div className='ps-3 my-3'>
              <div className='alert alert-dismissible bg-light-danger border border-danger border-dashed d-flex flex-column flex-sm-row w-100 p-5 my-5'>
                <ul className='d-flex flex-column'>
                  {message.errors?.map((error: any, index: number) => (
                    <li key={index} className='py-1'>
                      <span className='text-danger'>{error.detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : (
            isString(message) && (
              <div className='ps-3 my-3'>
                <div className='alert alert-dismissible bg-light-danger border border-danger border-dashed d-flex flex-column flex-sm-row w-100 p-5 my-5'>
                  <ul className='d-flex flex-column'>
                    <li className='py-1'>
                      <span className='text-danger'>{message}</span>
                    </li>
                  </ul>
                </div>
              </div>
            )
          )}
        </div>
      </OrderCard>
      {showDialog && (
        <ConfirmationDialog
          show
          isSubmitting={isSubmitting}
          onClose={handleClose}
          onConfirm={handleSave}
          title={`Reprocess ${app?.title} Order`}
          message='Are you sure you want to reprocess the order. however, it may take some time to complete?'
        />
      )}
    </>
  )
}

export default TrackingItem
